import { PropTypes } from "prop-types"

const InputError = ({ children, id }) => (
  <div className="oj-input-error" id={id}>
    {children}
  </div>
)

InputError.propTypes = {
  id: PropTypes.string.isRequired,
  children: PropTypes.node.isRequired
}

export default InputError
